<template>
    <div>
        <transition
            enter-active-class="transition ease-out duration-300 transform"
            enter-class="opacity-0"
            enter-to-class="opacity-100"
            leave-active-class="transition ease-out duration-300 transform"
            leave-class="opacity-100"
            leave-to-class="opacity-0"
        >
            <div
                class="flex grow items-center justify-center top-0 left-0 h-screen z-50 bg-deep-blue text-center -mt-12 mt-0 absolute w-full"
            >
                <div class="px-8">
                     <lottie-animation :loop="false" :width="180" :height="180" :path="global.app.path + 'animations/success-tick-circle.json'"/>
                    <h2 class="text-xl font-semibold mb-5">Completed</h2>
                    <p>
                        Thank you for submitting your application to Options Desk, we will process the application ASAP.
                    </p>
                    <p>Back to homepage: <a href="https://optionsdesk.com/">https://optionsdesk.com/</a></p>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    name: "SubmissionSuccessModalComponent",
    props: {},
    data: function () {
        return {};
    },
    computed: {
        ...mapGetters(["global"]),
    },
    methods: {

    },
    mounted() {
        this.$gtm.trackEvent({
            event: 'successful_submission',
            category: 'Submissions',
            action: 'Successful application submission',
            label: this.$route.path,
        });
    },
};
</script>
